import styled from 'styled-components';

export const ZillowNavbarHamburgerBox = styled.span`
    width: 18px;
    height: 18px;
    display: inline-block;
    position: relative;
`;
